// Re-export types from generated client
export type { Announcement, AnnouncementCategory } from 'js/src/client';

export const ANNOUNCEMENT_ACTIONS = {
    STORE_ANNOUNCEMENTS: 'STORE_ANNOUNCEMENTS',
    SET_LOADING_ANNOUNCEMENTS: 'SET_LOADING_ANNOUNCEMENTS',
    SET_ANNOUNCEMENTS_UNREAD_COUNT: 'SET_ANNOUNCEMENTS_UNREAD_COUNT',
    MARK_ANNOUNCEMENT_VIEWED: 'MARK_ANNOUNCEMENT_VIEWED',
};
